import { URL } from '../../../../config'
import { getRequest, postRequest } from '../../../../utils/httpRequest'

export const getUsers = function (searchBy, searchValue, token) {
  const searchEndpoint = `/search`;
  const criteria = typeof (searchValue) == 'number' ? searchValue.toString() : searchValue;
  const userUrl = `${URL.user}${searchEndpoint}/${searchBy}/${criteria}`;
  return getRequest(userUrl, 'json', token);
}

export const approveUser = function (id, token) {
  const approveEndpoint = `/${id}/approveaccess`;
  const approveUrl = `${URL.user}${approveEndpoint}`;
  return postRequest(approveUrl, 'json', token);
}

export const revokeAccess = function (id, token) {
  const revokeEndpoint = `/${id}/revokeaccess`;
  const revokeUrl = `${URL.user}${revokeEndpoint}`;
  return postRequest(revokeUrl, 'json', token);
}




// WEBPACK FOOTER //
// ./src/components/pages/UserManagement/api/index.js